<div
  *ngIf="ready && !visibility.isHidden"
  [style.visibility]="visibility.isInvisible ? 'hidden' : 'visible'"
>
  <label [for]="name" [innerHTML]="labelText"></label>
  <input
    [type]="type"
    class="form-control"
    dir="{{ dir$ | async }}"
    [value]="value"
    [name]="name"
    [placeholder]="placeholderText"
    [required]="required"
    [(ngModel)]="value"
  />
</div>
